// @ts-expect-error punycode.js ships no type declarations
import punycodeModule from 'punycode.js';

interface PunycodeDecoder {
  toUnicode(input: string): string;
}

const punycode: PunycodeDecoder = punycodeModule;

const PUNYCODE_LABEL_PREFIX = 'xn--';

const URL_WITH_HOST_PATTERN =
  /^([a-zA-Z][a-zA-Z0-9+.-]*:\/\/(?:[^/?#@]*@)?)([^/?#:]+)(.*)$/s;

function parseUrl(url: string): URL | null {
  try {
    return new URL(url);
  } catch {
    return null;
  }
}

function decodeHostname(hostname: string): string | null {
  try {
    return punycode.toUnicode(hostname);
  } catch {
    return null;
  }
}

export function toDisplayUrl(url: string): string {
  if (!url.toLowerCase().includes(PUNYCODE_LABEL_PREFIX)) return url;

  const parsed = parseUrl(url);
  if (!parsed) return url;

  const decodedHostname = decodeHostname(parsed.hostname);
  if (!decodedHostname || decodedHostname === parsed.hostname) return url;

  const match = URL_WITH_HOST_PATTERN.exec(url);
  if (!match) return url;

  const [, beforeHost = '', , afterHost = ''] = match;

  return `${beforeHost}${decodedHostname}${afterHost}`;
}
